import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { IonButton, IonImg, IonItem, IonLabel, IonText } from '@ionic/react';
import PayActions from 'redux/PayRedux';
import { useDispatch } from 'react-redux';
import moment from 'moment';

function OfferItem({ item, setShowAlert, setTermsEndDate }) {
  const dispatch = useDispatch();

  const offerItem = useMemo(() => {
    const offerDetailInfo = { ...item };

    if (item.type === 'single_visit') {
      if (
        item.multiVisitAction === 'purchase' &&
        Object.prototype.hasOwnProperty.call(offerDetailInfo, 'itemIds') &&
        offerDetailInfo.itemIds.length > 0
      ) {
        offerDetailInfo.promo_type = 'menu_combo';
      } else if (
        offerDetailInfo.multiVisitAction === 'visit' &&
        Object.prototype.hasOwnProperty.call(offerDetailInfo, 'itemIds') &&
        offerDetailInfo.itemIds.length > 0
      ) {
        offerDetailInfo.promo_type = 'item_quantity';
      } else {
        offerDetailInfo.promo_type = 'visit_spend';
      }
    } else if (item.type === 'multi_visit') {
      if (
        offerDetailInfo.multiVisitAction === 'purchase' &&
        Object.prototype.hasOwnProperty.call(offerDetailInfo, 'itemIds') &&
        offerDetailInfo.itemIds.length > 0
      ) {
        offerDetailInfo.action_type = 'purchase';
      } else if (item.multiVisitAction === 'visit') {
        offerDetailInfo.action_type = 'visit';
      } else {
        offerDetailInfo.action_type = 'spend';
      }
    }

    console.log("offer item", item);
    return { ...item, offer: offerDetailInfo };
  }, [item]);

  const renderProgressItem = (labelText, completedItem, lastItem) => {
    return (
      <>
        {
          completedItem ?
            <IonImg src="/assets/vemos-coin.png" className="offer-progress-coin" /> :
            <div className="offer-progress-text-wrap">
              <IonLabel color="warning" className="offer-progress-text">{labelText}</IonLabel>
            </div>
        }

        {
          !lastItem && <IonLabel color="warning" className="offer-progress-text">&#183;&#183;&#183;&#183;</IonLabel>
        }
      </>
    )
  }

  const renderProgressBar = (goal, progress) => {
    const _progress = progress.visit.count || progress.spend.amount || progress.purchase.uniqueVisits;

    const items = [];

    for (let i = 1; i <= goal; i += 1) {
      items.push(renderProgressItem(i, i <= _progress, i === goal));
    }

    return items;
  }

  const renderProgressContent = useCallback(() => {
    if (!offerItem.userProgress ||
      offerItem.type === "annual" ||
      offerItem.type === "single_visit"
    ) {
      return;
    }

    return (
      <div className="d-flex-row-center mb-2x">
        {
          renderProgressBar(offerItem.purchaseQuantity, 0) // TODO: replace 0 with actual progress
        }
      </div>
    );
  }, [offerItem]);

  const renderHeader = useCallback(() => {
    if (offerItem.type === 'multi_visit') {
      return (
        <div className="d-flex-row align-center offer-title-green-wrap">
          <IonLabel color="light" className="offer-item-title">
            {`Coin Boost! Get ${offerItem.rewardPoints} bonus coins`}
          </IonLabel>

          <IonImg src="/assets/vemos-coin.png" className="coin-img-icon" />
        </div>
      );
    }

    if (offerItem.type === 'single_visit' && offerItem.promo_type === 'menu_combo') {
      return (
        <div className="d-flex-row align-center offer-title-blue-wrap">
          <IonLabel color="light" className="offer-item-title">
            Winning Combination
          </IonLabel>
        </div>
      );
    }

    if (offerItem.type === 'single_visit' && offerItem.promo_type !== 'menu_combo') {
      return (
        <div className="d-flex-row align-center offer-title-orange-wrap">
          <IonLabel color="light" className="offer-item-title">
            Buy More, Earn More
          </IonLabel>
        </div>
      );
    }


    return (
      <div className="d-flex-row align-center offer-title-purple-wrap">
        <IonLabel color="light" className="offer-item-title">
          Happy {offerItem.annualEventType === 'birthday' ? 'Birthday' : 'Loyalty Anniversary'}
        </IonLabel>
      </div>
    );
  }, [offerItem]);


  const onActivateAction = () => {
    dispatch(PayActions.setActivateOffer(offerItem.id));
  }

  const onTermsAction = () => {
    setShowAlert(true);

    const currentDate = moment();
    const weekEnd = currentDate.clone().endOf('week');
    const monthEnd = currentDate.clone().endOf('month');
    let endOfDate = currentDate;

    if (item.type === 'annual') {
      if (item.durationType === 'limited') {
        endOfDate = item.endDate;
      } else if (item.annualEventTimeFrame === 'day') {
        endOfDate = currentDate;
      } else if (item.annualEventTimeFrame === 'week') {
        endOfDate = weekEnd;
      } else {
        endOfDate = monthEnd;
      }
    } else {
      endOfDate = item.annualEventTimeFrame;
    }

    setTermsEndDate(moment(endOfDate).format("YYYY-MM-DD"));
  }

  return (
    <IonItem lines="none" className="mb-5x">
      <div className="offer-item-wrap">

        {renderHeader()}

        <div className="offer-item-content">
          {renderProgressContent()}

          <IonText color="primary" className="offer-primary-text">
            {offerItem.name}
          </IonText>

          <div className="d-flex-row">
            <IonText color="primary" className="offer-secondary-text">
              {offerItem.description}
            </IonText>
          </div>

          {
            offerItem.userProgress && offerItem.userProgress.completed ?
              <div className="d-flex-row align-center justify-between">
                <div className="d-flex-row align-center">
                  <IonLabel color="tertiary" className="offer-item-terms-text">Completed&nbsp;<span role="img" aria-label="Symbola">🎉</span></IonLabel>
                </div>
              </div>
              : !offerItem.userProgress && offerItem.type !== "annual" ? /* no progress means it's not activated yet */
                <div className="d-flex-row align-center justify-between mt-2x">
                  <IonButton
                    color="secondary"
                    expand="block"
                    fill="outline"
                    type="button"
                    className="offer-activate-btn"
                    onClick={onActivateAction}
                  >
                    Activate
                  </IonButton>

                  <IonButton
                    expand="block"
                    fill="clear"
                    type="button"
                    onClick={onTermsAction}
                  >
                    <IonLabel color="success" className="offer-item-terms-text">Terms</IonLabel>
                  </IonButton>
                </div>
                :
                <div className="d-flex-row align-center justify-between-end mt-2x">
                  <IonButton
                    expand="block"
                    fill="clear"
                    type="button"
                    onClick={onTermsAction}
                  >
                    <IonLabel color="success" className="offer-item-terms-text">Terms</IonLabel>
                  </IonButton>
                </div>
          }
        </div>
      </div>
    </IonItem>
  );
}

OfferItem.propTypes = {
  item: PropTypes.object,
  setShowAlert: PropTypes.func,
  setTermsEndDate: PropTypes.func,
};

export default OfferItem;
